import axios from 'axios'
import _get from 'lodash/get'

import { handleRequestError } from './request'

export const REQUEST_ISSUES = 'REQUEST_ISSUES'
export const RECEIVE_ISSUES = 'RECEIVE_ISSUES'

export const requestIssues =
    (selfAssessmentId = null) =>
    (dispatch) => {
        dispatch({ type: REQUEST_ISSUES, data: { selfAssessmentId } })

        const url = `/issues${selfAssessmentId ? `?selfAssessmentId=${selfAssessmentId}` : ''}`

        axios
            .get(url)
            .then((response) => {
                const items = _get(response, ['data'], [])
                dispatch(receiveIssues({ items, fetchSuccessful: true }))
            })
            .catch((error) => {
                dispatch(receiveIssues({ fetchSuccessful: false }))
                dispatch(handleRequestError(error))
            })
    }

export const receiveIssues = (data) => ({ type: RECEIVE_ISSUES, data })
